import { Navigate, useLocation } from 'react-router-dom';
import { trpc } from '@/trpc/client';
import { useLocationId } from '@/hooks/useLocationId';

/**
 * Catches old URLs without /location/ prefix (e.g. /contacts/abc)
 * and redirects to /location/:slug/contacts/abc.
 * Ensures backwards compatibility with bookmarks and shared links.
 */
export function LegacyRedirect() {
  const location = useLocation();
  const effectiveLocationId = useLocationId();
  const { data: loc } = trpc.location.getById.useQuery(
    { id: effectiveLocationId! },
    { enabled: !!effectiveLocationId }
  );

  if (!loc) return null; // Loading

  return (
    <Navigate
      to={`/location/${loc.slug}${location.pathname}${location.search}`}
      replace
    />
  );
}
